module.exports = __webpack_public_path__ + "img/172624.6b50c60b.png";